import { render, staticRenderFns } from "./InvalidTable.vue?vue&type=template&id=01b19d37"
import script from "./InvalidTable.vue?vue&type=script&lang=js"
export * from "./InvalidTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports